export const uk = {
    'client-id': 'ClientID',
    'full-name': 'ФИО',
    login: 'Логин',
    products: 'Список управляемых продуктов'
};
